export default "__VITE_ASSET__CoIns92m__"